import { kintFirestore } from '~kint/firebase/firestore.ts';
import { IChatting } from '~kint/models/Chatting.ts';

export async function getChatting(chattingId: string): Promise<IChatting | null> {
  const doc = await kintFirestore.readDoc<IChatting>('chats', chattingId);
  if (!doc) return null;
  return doc;
}
